module.exports = "/static/assets/48ed62bb2875adc2cf9739588bb16c4b.png";